export default __webpack_public_path__ + "static/media/delete.be5187bb.svg";